import { render, staticRenderFns } from "./AccessDeniedView.vue?vue&type=template&id=949a5602&scoped=true"
import script from "./AccessDeniedView.vue?vue&type=script&lang=js"
export * from "./AccessDeniedView.vue?vue&type=script&lang=js"
import style0 from "./AccessDeniedView.vue?vue&type=style&index=0&id=949a5602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949a5602",
  null
  
)

export default component.exports